const getters = {
  getMe: state => state.me,
  getUsers: state => state.users
}


export default getters